import { ConfigSettingDto } from '../model/business/ConfigSettingDto';
import { SessionService } from 'src/app/session-service.service';
import { OnInit, Input, Directive } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';

@Directive()
export abstract class BaseComponent implements OnInit {
  @Input()
  placeholder = 'NOPLACEHOLDER';

  @Input()
  secondPlaceholder = 'NOPLACEHOLDER';

  @Input()
  control: FormControl;

  @Input()
  controlInput: FormControl;

  @Input('form')
  fg: FormGroup;

  @Input()
  showPlaceholder = true;

  @Input()
  showSecondPlaceholder = true;

  @Input('required')
  isRequired = false;

  @Input()
  isRequiredMessageKey = '';

  @Input()
  maxlength = Number.MAX_VALUE;

  @Input()
  isMaxLengthMessageKey = '';

  Object = Object;

  isRequiredMessage = '';
  isMaxLengthMessage = '';
  translatedPlaceholder: string;
  translatedSecondPlaceholder: string;

  abstract controlType;
  hasFocus: boolean;
  private translateService: TranslateService;
  configSettingsDto: ConfigSettingDto;

  constructor(translateService: TranslateService, public sessionService: SessionService) {
    this.translateService = translateService;
  }

  ngOnInit(): void {
    try {
      if (
        this.placeholder === 'NOPLACEHOLDER' &&
        (this.isRequired || this.showPlaceholder)
      ) {
        throw new Error(
          'placeholder property not specified, but component is marked as required or has to show placeholder'
        );
      }

      this.placeholder !== 'NOPLACEHOLDER'
          ? this.translateService.get(this.placeholder).subscribe(result => {
            this.translatedPlaceholder = result;
          })
          :  this.translatedPlaceholder = 'NOPLACEHOLDER';

      this.secondPlaceholder !== 'NOPLACEHOLDER'
          ? this.translateService.get(this.secondPlaceholder).subscribe(result => {
            this.translatedSecondPlaceholder = result;
          })
          :  this.translatedSecondPlaceholder = 'NOPLACEHOLDER';

      const isRequiredMessageKey = this.isRequiredMessageKey === '' ?
        'Common.RequiredValidatorMessage' :
        this.isRequiredMessageKey;

      const isMaxLengthMessageKey = this.isMaxLengthMessageKey === '' ?
        'Common.MoreThanValidatorMessage' :
        this.isMaxLengthMessageKey;

      this.translateService.get([isRequiredMessageKey, isMaxLengthMessageKey])
        .subscribe((results) => {
          this.isRequiredMessage = results[isRequiredMessageKey]
            .replace('%%',  this.translatedPlaceholder);

          this.isMaxLengthMessage = results[isMaxLengthMessageKey]
            .replace('%%',  this.translatedPlaceholder);
        });
    } catch (e) {
      console.error(
        `Failed initializing ${this.controlType} with placeholder '${this.placeholder
        }' and controlName '${this.getName(
          this.control
        )}'. InnerException follows: ${e}`
      );
    }
  }

  onFocus(): void {
    this.hasFocus = true;
  }

  onFocusOut(): void {
    this.hasFocus = false;
  }

  controlStateIsError(validationType): boolean {
    return (
      this.control.hasError(validationType) &&
      (this.control.dirty || this.control.touched)
    );
  }

  private getName(control: FormControl): string | null {
    const group = control.parent as FormGroup;

    if (!group) {
      return null;
    }

    let name: string;

    Object.keys(group.controls).forEach((key) => {
      const childControl = group.get(key);

      if (childControl !== control) {
        return;
      }

      name = key;
    });

    return name;
  }

  get requiredError(): boolean {
    if (this.control.errors?.required) {
      return true;
    }
    return false;
  }

  get messageError(): boolean {
    if (this.control.errors?.message) {
      return true;
    }
    return false;
  }

  get isAnyError(): boolean {
    return this.control.invalid && (this.control.dirty || this.control.touched);
  }
}
